module.exports = __webpack_public_path__ + "static/how-emotions-are-made-86e11dc1bed4f360c247e10b2da33c71.jpg";